import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { Component, render } from 'preact';
import { deleteCartInProduct, getSession, updateCartInProductQuantity } from '../api/Client';
import { currencyFormat } from '../util/Formatter';
import { ReccuringUtil } from '../util/Reccuring';
import LineLoginComponent from './LineLoginComponent';
export class CartComponent extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            storeType: "",
            paymentSplitable: false,
            cartDetails: [],
            paymentForm: null,
            lineUserId: null,
        };
    }
    componentDidMount() {
        getSession().then(response => {
            const { cartDetails, lineUserId } = response.data;
            this.setState({
                cartDetails: cartDetails,
                lineUserId: lineUserId,
            });
        }).catch(e => {
            alert('カートセッションの取得に失敗しました');
            throw e;
        });
    }
    render() {
        // LINE連携に関わるボタンの非活性制御
        const submitButton = document.getElementById('cartFormSubmitButton');
        const lineMagazineSubscribableCount = this.state.cartDetails.filter(p => p.magazineSubscribable === true).length;
        const lineAuthorized = (this.state.lineUserId ?? '').length > 0;
        if (lineMagazineSubscribableCount > 0 && lineAuthorized === false) {
            submitButton?.setAttribute('disabled', 'disabled');
        }
        else {
            submitButton?.removeAttribute('disabled');
        }
        // エラーがある場合の活性制御
        if (this.state.errorMessage) {
            submitButton?.setAttribute('disabled', 'disabled');
        }
        else {
            submitButton?.removeAttribute('disabled');
        }
        if (this.state.cartDetails.length > 0) {
            const cartLists = this.state.cartDetails.map((v, index) => _jsxs("ul", Object.assign({ className: index === this.state.cartDetails.length - 1 ? 'listgroup listgroup__cartin last' : 'listgroup listgroup__cartin' }, { children: [_jsxs("li", Object.assign({ class: "icon-text", onClick: () => this.removeProduct(v.productId) }, { children: [_jsx("i", { class: "fas fa-times mr1" }, void 0),
                            _jsx("span", Object.assign({ class: "icon__text" }, { children: "\u524A\u9664" }), void 0)] }), void 0),
                    _jsxs("li", { children: [_jsx("h5", Object.assign({ class: "head" }, { children: "\u5546\u54C1\u540D" }), void 0),
                            _jsxs("p", Object.assign({ class: "body" }, { children: [v.productName, "(", v.productCode, ")"] }), void 0)] }, void 0),
                    _jsxs("li", { children: [_jsx("h5", Object.assign({ class: "head" }, { children: "\u6570\u91CF" }), void 0),
                            _jsx("div", Object.assign({ class: "body field" }, { children: _jsxs("div", Object.assign({ class: "control" }, { children: [_jsx("input", { type: "number", class: `input ${this.hasQuantityError(v.productId) ? 'is-danger' : ''}`, value: v.quantity, onChange: e => this.setQuantity(e, v.productId), required: true }, void 0), this.getMessage(v.productId)] }), void 0) }), void 0)] }, void 0),
                    _jsxs("li", { children: [_jsx("h5", Object.assign({ class: "head" }, { children: "\u521D\u56DE\u8ACB\u6C42\u91D1\u984D" }), void 0),
                            _jsxs("p", Object.assign({ class: "body" }, { children: [_jsx("span", Object.assign({ data: "cartsubtotal" }, { children: currencyFormat(this.subTotal(v.productId)) }), void 0), _jsxs("span", Object.assign({ class: "ml1" }, { children: ["(\u5358\u4FA1:", currencyFormat(v.unitPrice), ")"] }), void 0)] }), void 0)] }, void 0),
                    _jsx("li", { children: _jsxs("div", Object.assign({ class: "body field is-grouped is-grouped-multiline" }, { children: [_jsx("div", Object.assign({ class: "control" }, { children: _jsxs("div", Object.assign({ class: "tags has-addons" }, { children: [_jsx("span", Object.assign({ class: "tag is-dark" }, { children: "\u7A2E\u5225" }), void 0),
                                            _jsx("span", Object.assign({ class: "tag is-info" }, { children: this.productType(v.productId) }), void 0)] }), void 0) }), void 0),
                                _jsx("div", Object.assign({ class: "control" }, { children: _jsxs("div", Object.assign({ class: "tags has-addons" }, { children: [_jsx("span", Object.assign({ class: "tag is-dark" }, { children: "\u652F\u6255\u65B9\u6CD5" }), void 0),
                                            _jsx("span", Object.assign({ class: "tag is-info" }, { children: this.productPaymentMethodType(v.productId) }), void 0)] }), void 0) }), void 0), this.reccuringBadge(v)] }), void 0) }, void 0)] }), void 0));
            cartLists.push(_jsxs("ul", Object.assign({ class: "listgroup__footer" }, { children: [_jsxs("li", { children: [_jsx("h4", Object.assign({ class: "head" }, { children: "\u5408\u8A08\u91D1\u984D" }), void 0),
                            _jsx("span", { children: currencyFormat(this.getPayTotal()) }, void 0)] }, void 0),
                    _jsx(LineLoginComponent, { userId: this.state.lineUserId, cartDetails: this.state.cartDetails }, void 0)] }), void 0));
            return (_jsx(_Fragment, { children: cartLists }, void 0));
        }
        return (_jsx("div", Object.assign({ class: "notification is-primary is-light" }, { children: "\u5546\u54C1\u304C\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u305B\u3093" }), void 0));
    }
    removeProduct(id) {
        deleteCartInProduct(id).then(() => {
            const removedProduct = this.state.cartDetails.filter(p => p.productId !== id);
            this.setState({ cartDetails: removedProduct });
        }).catch(e => {
            alert('カートイン済みの商品の削除に失敗しました');
            throw e;
        });
    }
    subTotal(productId) {
        const product = this.getProduct(productId);
        if (!product) {
            return 0;
        }
        switch (product.settlementType) {
            case "UNIT_PRICE":
                return product.unitPrice * product.quantity;
            case "UNITPLUSRECCURING":
                return (product.unitPrice + (product.reccuringPrice ?? 0)) * product.quantity;
            case "RECCURING":
                return (product.reccuringPrice ?? 0) * product.quantity;
            default:
                return 0;
        }
    }
    productType(productId) {
        const product = this.getProduct(productId);
        return product?.paymentType === 'RECCURING' ? '継続' : '都度';
    }
    productPaymentMethodType(productId) {
        const product = this.getProduct(productId);
        return product?.paymentSplit ? '分割可' : '一括のみ';
    }
    setQuantity(e, productId) {
        const cartDetails = this.state.cartDetails;
        const target = e.target;
        if (target.value.length === 0) {
            return;
        }
        const quantity = Number(target.value);
        for (let idx = 0; idx < cartDetails.length; idx++) {
            if (cartDetails[idx].productId === productId) {
                cartDetails[idx].quantity = quantity;
            }
        }
        this.setState({ cartDetails: cartDetails, errorMessage: null });
        updateCartInProductQuantity(productId, quantity).catch(e => {
            if (e.response) {
                this.setState({
                    errorMessage: {
                        key: productId,
                        message: e.response.data.message
                    }
                });
            }
        });
    }
    getProduct(productId) {
        const product = this.state.cartDetails.filter(p => p.productId === productId);
        if (product.length > 0) {
            return product[0];
        }
        return null;
    }
    getPayTotal() {
        return this.state.cartDetails.map(m => this.subTotal(m.productId)).reduce((a, c) => a + c);
    }
    reccuringBadge(cartDetail) {
        if (cartDetail.paymentType === "EACHTIME") {
            return null;
        }
        const results = [];
        results.push((_jsx("div", Object.assign({ class: "control" }, { children: _jsxs("div", Object.assign({ class: "tags has-addons" }, { children: [_jsx("span", Object.assign({ class: "tag is-dark" }, { children: "\u7D99\u7D9A\u984D" }), void 0),
                    _jsx("span", Object.assign({ class: "tag is-info" }, { children: currencyFormat(cartDetail.reccuringPrice) }), void 0)] }), void 0) }), void 0)));
        if (cartDetail.reccuringLimit) {
            results.push((_jsx("div", Object.assign({ class: "control" }, { children: _jsxs("div", Object.assign({ class: "tags has-addons" }, { children: [_jsx("span", Object.assign({ class: "tag is-dark" }, { children: "\u56DE\u6570" }), void 0),
                        _jsxs("span", Object.assign({ class: "tag is-info" }, { children: [cartDetail.reccuringLimit, "\u56DE"] }), void 0)] }), void 0) }), void 0)));
        }
        const start = ReccuringUtil.nextReccuringDate(cartDetail.paymentUnit, cartDetail.nextReccuringDate ?? "00", cartDetail.nextReccuringGracePeriod ?? 0);
        const end = ReccuringUtil.endOfReccuringDate(cartDetail.reccuringLimit, cartDetail.paymentUnit, start);
        const paymentUnitLabel = ReccuringUtil.cycleLabel(cartDetail.paymentUnit, start);
        results.push((_jsx("div", Object.assign({ class: "control" }, { children: _jsxs("div", Object.assign({ class: "tags has-addons" }, { children: [_jsx("span", Object.assign({ class: "tag is-dark" }, { children: "\u30B5\u30A4\u30AF\u30EB" }), void 0),
                    _jsx("span", Object.assign({ class: "tag is-info" }, { children: paymentUnitLabel }), void 0)] }), void 0) }), void 0)));
        results.push((_jsx("div", Object.assign({ class: "control" }, { children: _jsxs("div", Object.assign({ class: "tags has-addons" }, { children: [_jsx("span", Object.assign({ class: "tag is-dark" }, { children: "\u7D99\u7D9A\u671F\u9593" }), void 0),
                    _jsxs("span", Object.assign({ class: "tag is-info" }, { children: [start.format('YYYY/MM/DD'), " ~ ", cartDetail.reccuringLimit ? end.format('YYYY/MM/DD') : '無期限'] }), void 0)] }), void 0) }), void 0)));
        return results;
    }
    hasQuantityError(productId) {
        if (this.state.errorMessage) {
            return this.state.errorMessage.key === productId;
        }
        return false;
    }
    getMessage(productId) {
        if (this.state.errorMessage && this.state.errorMessage.key === productId) {
            return (_jsx("p", Object.assign({ class: "help is-danger" }, { children: this.state.errorMessage.message }), void 0));
        }
        return null;
    }
}
document.addEventListener('DOMContentLoaded', () => {
    const mount = document.querySelector('#CartListComponent');
    if (mount) {
        render(_jsx(CartComponent, {}, void 0), mount);
    }
});
